import HomeContainer from "../../containers/Home";

interface Props {}

function Home(props: Props) {
  return <HomeContainer />;
}

export default Home;
